var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m4.022 14.5 6.663 6.272-1.37 1.456-9.251-8.706 9.229-9.23 1.414 1.415L3.914 12.5H26v2H4.022Z",
    clipRule: "evenodd"
  })));
};
export { SvgArrowLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjAyMTU4IDE0LjVMMTAuNjg1NCAyMC43NzE4TDkuMzE0NjQgMjIuMjI4MkwwLjA2NDAzMzUgMTMuNTIxOEw5LjI5Mjg5IDQuMjkyODlMMTAuNzA3MSA1LjcwNzExTDMuOTE0MjEgMTIuNUwyNiAxMi41VjE0LjVMNC4wMjE1OCAxNC41WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";